const trimInputData = (obj) => {
  const trimmedInputData = {};
  for (const key in obj) {
    if (!obj[key] || Array.isArray(obj[key])) {
      trimmedInputData[key] = obj[key];
    } else if (typeof obj[key] === "object") {
      trimmedInputData[key] = trimInputData(obj[key]);
    } else if (typeof obj[key] === "string") {
      trimmedInputData[key] = obj[key].trim();
    } else {
      trimmedInputData[key] = obj[key];
    }
  }
  return trimmedInputData;
};
export {
  trimInputData
};
//# sourceMappingURL=trim-input-data.js.map
